export const keyFetchUserLogin = 'KEY_USER_LOGGEDIN';
export const keyIsLoggedIn = 'KEY_IS_LOGGEDIN';
export const keyUserToken = 'KEY_USER_TOKEN';

export const GlobalLoading = 'GLOBAL_LOADING'
export const RoleUserAdmin = 'RoleUserAdmin'
export const RoleCustomerService = 'RoleCustomerService'
export const RoleUploaderStaff = 'RoleUploaderStaff'
export const RoleUploaderSPV = 'RoleUploaderSPV'
export const RoleCSAgent = 'RoleCSAgent'
export const RoleCSSPV = 'RoleCSSPV'

export const GetUsers = 'GETUSERS'
export const GetUserAll = 'GETUSERSALL'
export const GetPrevilage = 'GETPREVILAGE'
export const GetPrevilageAll = 'GETPREVILAGEALL'
export const GetCheckContact = 'GETCHECKCONTACT'
export const GetAccessModule = 'GETACCESSMODULE'
export const GetHelpdeskCS = 'GETHELPDESKCS'
export const GetHelpdeskCSAll = 'GETHELPDESKCSALL'
export const GetSupervisor = 'GETSUPERVISOR'
export const GetSupervisorAll = 'GETSUPERVISORALL'
export const GetTemplate = 'GETTEMPLATE'
export const GetGroupTemplate = 'GETGROUPTEMPLATE'
export const GetTemplateFirst = 'GETTEMPLATEFIRSTPAGE'
export const GetTemplateAll = 'GETTEMPLATEALL'
export const GetDivisionAll = 'GETDIVISIONALL'
export const GetCategory = 'GETCATEGORY'
export const GetCategoryAll = 'GETCATEGORYALL'
export const GetClientAll = 'GETCLIENTAll'
export const GetClientSmsAll = 'GETCLIENTSMSAll'
export const GetBusinessHour = 'GETBUSINESSHOUR'
export const GetHoliday = 'GETHOLIDAY'
export const GetPriority = 'GETPRIORITY'
export const GetPriorityAll = 'GETPRIORITYALL'
export const GetKeyGroup = 'GETKEYGROUP'
export const GetKeyGroupAll = 'GETKEYGROUPALL'
export const GetReply = 'GETREPLY'
export const GetInvalidReply = 'GETINVALIDREPLY'
export const GetRepliesCloseTicket = 'GETREPLIESCLOSETICKET'
export const GetWaMappingResponse = 'GETWAMAPPINGRESPONSE'
export const GetResponseCode = 'GETRESPONSECODE'
export const GetDivisionSetting= 'GETDIVISIONSETTING'
export const GetSenderSetting = 'GETSENDERSETTING'

export const GetChatList = 'GETCHATLIST'
export const GetChatMessage = 'GETCHATMESSAGE'
export const GetChatHistory = 'GETCHATHISTORY'
export const GetChatMessageHistory = 'GETCHATMESSAGEHISTORY'
export const GetWAProfile = 'GETWAPROFILE'
export const GetSenderAll = 'GETSENDERALL'
export const GetUploadDetail = 'GETUPLOADDETAIL'

export const GetTicketHistory = 'GETTICKETHISTORY'
export const GetDetailTicket = 'GETDETAILTICKET'
export const GetHSMTemplate = 'GETHSMTEMPLATE'
export const GetHSMTemplateAll = 'GETHSMTEMPLATEALL'
export const GetUploadMediaId = 'GETUPLOADMEDIAID'
export const GetMediaIdName = 'GETMEDIAIDNAME'

export const GetFacebookTemplateData = 'GETFACEBOOKTEMPLATEDATA'

//Flow Template
export const GetFlowTemplate = 'GETFLOWTEMPLATE'
export const GetFlowTemplateAll = 'GETFLOWTEMPLATEALL'

//repoort
export const GetReportBroadCastList = 'GETREPORTBROADCASTLIST'
export const GetReportInteractive = 'GETREPORTINVERACTIVE'
export const GetReportHelpdesk = 'GETREPORTHELPDESK'
export const GetWaToSMS = 'GETWATOSMS'
export const GetReportGraphic = 'GETEPORTGRAPHIC'
export const GetReportDashboard = 'GETREPORTDASHBOARD'
export const GetWaToSMSHeader = 'GETWATOSMSHEADER'
export const GetWaToSMSDetail = 'GETWATOSMSDETAIL'
export const GetSenderNamespace = 'GETSENDERNAMESPACE'
export const GetTemplateSender = 'GETTEMPLATESENDER'
export const GetAccessModuleAction = 'GETACCESSMODULEACTION'
export const GetReportButtonList = 'GETREPORTBUTTONLIST'

//Wa Profile
export const GetWaProfileSetting = 'GET_WA_PROFILE_SETTING'
export const GetWaProfileImage = 'GET_WA_PROFILE_IMAGE'

export const IsEdit = 'Edit'
export const IsCreate = 'New'
export const IsView = 'Detail'
export const IsUpload = 'Upload'

export const DefaultPageSize = 10

export const InputTypeTextInput = '1'
export const InputTypeDropdown = '2'
export const InputTypeCombobox = '3'


export const GetCategoryTemplate = 'GETCATEGORYTEMPLATE'
export const GetLanguageTemplate = 'GETLANGUAGETEMPLATE'
export const GetTemplateFacebook = 'GETTEMPLATEFACEBOOK'
export const GetNameSpace = 'GETNAMESPACE'
export const GetTransmitter = 'GETTRANSMITTER'
export const GetBacklogClient = 'GETBACKLOGCLIENT'

export const GetBotInquiry='GETBOTINQUIRY'
export const GetVolumeBot='GETVOLUMEBOT'
export const GetInteractiveSummary='GETINTERACTIVESUMMARY'
export const GetTotalTicket='GETTOTALTICKET'
export const GetTicketHour='GETTICKETHOUR'
export const GetTicketTopic='GETTICKETTOPIC'
export const GetAverage='GETAVERAGE'
export const GetTicketDay='GETICKETDAY'

export const GetHomePushSummary = 'GETHOMEPUSHSUMMARY'
export const GetHomeInteractiveSummary = 'GETHOMEINTERACTIVESUMMARY'
export const GetHomeTemplateSummary = 'GETHOMETEMPLATESUMMARY'

export const GetDailyMessageByStatus = 'GETDAILYMESSAGEBYSTATUS'
export const GetReadRateByDay = 'GETREADRATEBYDAY'
export const GetReadRateByTime = 'GETREADRATEBYTIME'
export const GetPushFormatDistribution = 'GETPUSHFORMATDISTRIBUTION'
export const GetBatchName = 'GETBATCHNAME'
export const GetHighestReadRate = 'GETHIGHESTREADRATE'

//Report Session
export const GetReportSessionDashboard = 'GETREPORTSESSIONDASHBOARD'
export const GetReportSession = 'GETREPORTSESSION'

//quality rating
export const GetQualityRating = 'GETQUALITYRATING'